import * as React from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import Search from "../../shared/Search";
import { CustomIconButton } from "../../shared/CustomIconButton";
import { toast } from "react-toastify";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Switch from "@mui/material/Switch";

const BusinessCategory = () => {
  const [data, setData] = useState([]);
  const BuisenesCategoryList = () => {
    axios
      .post(
        `https://app1.crazzyhub.com/api/admin/multivendor-business-category-list-data/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data?.business_category_list_data);
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
      });
  };
  useEffect(() => {
    BuisenesCategoryList();
  }, []);

  const ActiveData = (event, id) => {
    event.preventDefault()
    axios
      .post(
        `https://app1.crazzyhub.com/api/deactivate-business-type-multivendor/`,
        { business_type_ids: [id] },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast("De-Activated Success fully...!");
        BuisenesCategoryList()
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
      })
      
      //  
  };

  const deActiveData=(event, id)=>{
    event.preventDefault();
    axios
      .post(
        `https://app1.crazzyhub.com/api/activate-business-type-multivendor/`,
        { business_type_ids: [id] },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast("Activated Success fully...!");
        BuisenesCategoryList()
      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
      })
  }

  return (
    <>
      <div className="">
        <div className="flex justify-between">
          <div className="p-2">
            <p className="text-xl fon text-gray-800 font-bold">
              Business Type List
            </p>
          </div>
          {/* <AddBussinessCategory /> */}
        </div>
      </div>
      <div className="flex flex-col !my-3 !rounded bg-dark border-secondary shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center bg-gray-100 justify-between p-2 h-14">
          <div className="flex bg-secondary">
            {/* <CustomIconButton>
              <FilterAltIcon className="text-black" />
            </CustomIconButton> */}
            <Search />
          </div>
        </div>
        <div className="">
          <TableContainer
            component={Paper}
            // sx={{  }}
            sx={{ width: "100%", maxHeight: 440 }}
            className="!text-black !mx-auto !bg-white overflow-auto px-2"
          >
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    Id
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    Business Type
                  </TableCell>
                  <TableCell
                    style={{
                      borderRight: "1px solid #D0D0D0",
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    Status
                  </TableCell>
                  <TableCell
                    style={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                    className="!text-center !text-gray-800 !font-bold"
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data &&
                  data?.map((cat) => {
                    return (
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                          component="th"
                          scope="row"
                        >
                          {cat?.id}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {cat?.name}
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            borderRight: "1px solid #D0D0D0",
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          <div className="mx-auto">
                            {
                              cat?.active_status ? 
                              <Switch
                              defaultChecked={cat?.active_status}
                              onChange={(event) => ActiveData(event, cat?.id)}
                              inputProps={{ 'aria-label': 'controlled' }}
                             
                            />
                            :
                            <Switch
                              defaultChecked={cat?.active_status}
                              onChange={(event) => deActiveData(event, cat?.id)}
                              inputProps={{ 'aria-label': 'controlled' }}
                            />
                            }
                            
                          </div>
                        </TableCell>
                        <TableCell
                          className="!text-center !text-[12px]"
                          style={{
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          <div className=" mx-auto justify-center text-center items-center">
                            <CustomIconButton>
                              <BorderColorIcon className="!text-center text-green-500" />
                            </CustomIconButton>
                            <CustomIconButton>
                              <DeleteIcon className="!text-center text-red-500" />
                            </CustomIconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );
};

export default BusinessCategory;
